import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { environment } from 'environments/environment';
import { AbstractService } from './abstract.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { defaultSupportedLanguages, defaultSupportedLanguageCodes } from 'app/main/helpers/i18n.helper';

export const appConfig = {
	serverAddress: environment.serverAddress,
	serverPort: environment.serverPort,
	apiRoutePrefix: environment.apiRoutePrefix,
	sessionMaxAge: environment.sessionMaxAge,

	websocket: environment.websocket
};

@Injectable()
export class AppService extends AbstractService{

	public defaultLangs = defaultSupportedLanguages;

	public selectedLanguage: BehaviorSubject<any>;
	public loading: BehaviorSubject<boolean>;
	public appData: BehaviorSubject<any>;
	public languages: BehaviorSubject<any>;
	public languageChanging: BehaviorSubject<boolean>;
	public loadingLanguages: BehaviorSubject<boolean>;

	public onLanguageChange: EventEmitter<any>;

	// snackbar
	public showSnackbar: boolean;
	public snackbarText: string;

	private loadSubscription: Subscription;

	constructor(protected http: HttpClient, protected router: Router){
		super(http, router);
		this.appData = new BehaviorSubject<any>(null);
		this.selectedLanguage = new BehaviorSubject<any>('en');
		this.loading = new BehaviorSubject<boolean>(false);
		// usato per disabillitare la select mentre le lingue nel caso di un record si caricano
		this.loadingLanguages = new BehaviorSubject<boolean>(false);
		// usato per scatenare il loader in app.component al change della lingua nella select
		this.languageChanging = new BehaviorSubject<boolean>(false);
		// inizializzo lingue per popolare la select (prende un array di codici delle lingue)
		this.languages =  new BehaviorSubject<any>(defaultSupportedLanguageCodes);
		// event language change
		this.onLanguageChange = new EventEmitter<any>();
	}

	setLanguages(langs?: any[]): void{
		if (langs){
			this.languages.next(langs);
		} else {
			this.languages.next(defaultSupportedLanguageCodes);
		}
	}

	getServerAddress(defaultValue: any = ''): any{
		let address = appConfig.serverAddress;
		if(appConfig.serverPort && address){
			address += ':' + appConfig.serverPort;
		}
		return address || defaultValue;
	}

	getBaseServerAddress(defaultValue: any = ''): any{
		let address = this.getServerAddress();
		if(appConfig.apiRoutePrefix){
			address += appConfig.apiRoutePrefix;
		}
		return address;
	}

	get domain(): any{
		return this.appData.value?.domain;
	}

	get domainId(): any{
		return this.domain?.id;
	}

	get Logo(): any{
		return this.domain?.logo;
	}

	get Entity(): any{
		return this.domain?.entity;
	}

	get PrimaryAddress(): any{
		return this.Entity?.primary_address;
	}

	get Categories(): any{
		return this.appData.value?.trip_package_categories_domain;
	}

	languageChange(lang: string): Observable<any>{
		const result = new Subject<any>();
		this.loading.next(true);
		this.http.post(this.getBaseServerAddress() + '/set-language/' + lang, null)
		.subscribe({
			next: (newLang) => {
				this.selectedLanguage.next(newLang);
				result.next(newLang);
				result.complete();
				this.loading.next(false);
			},
			error: (response) => {
				result.next('en');
				result.complete();
				this.loading.next(false);
			}
		});
		return result;
	}

	loadAppData(domainId: any): Observable<any>{
		const result = new Subject<any>();
		this.http.get(this.getBaseServerAddress() + '/app_data/' + domainId)
		.subscribe({
			next: (response: any) => {
				this.selectedLanguage.next(response.lang);
				this.appData.next(response);
				result.next(response);
				result.complete();
			},
			error: (response) => {
				this.appData.next(null);
				result.next();
				result.complete();
			}
		});
		return result;
	}

	createManifestPWA(domainId: any): Observable<boolean>{
		const myDynamicManifest = new Subject<any>();
		const route = this.getBaseServerAddress() + '/manifest/' + domainId;
		if (this.loadSubscription && !this.loadSubscription.closed) this.loadSubscription.unsubscribe();
		this.loadSubscription = this.http.get(route)
		.subscribe({
			next: (response) => {
				myDynamicManifest.next(response);
				myDynamicManifest.complete();
			},
			error: (response) => {
				myDynamicManifest.next(null);
				myDynamicManifest.complete();
			}
		});
		return myDynamicManifest;
	}

	showSnackbarMessage(): void{
		this.showSnackbar = true;
		setTimeout(() => this.showSnackbar = false, 5000);
	}
}
